import gql from "graphql-tag";

const PRIVACY_POLICY = gql`
  query GetPrivacyPolicy {
    privacyPolicy
  }
`;

export default PRIVACY_POLICY;
